module.exports = __webpack_public_path__ + "80c93cc1698374dfcccae746fec7fade.gif";